import { LogLevel } from "angular-auth-oidc-client";

export class AuthConfig {
  public static redirectUrl = window.location.origin + "/index.html";
  public static logLevel = LogLevel.None;
}
